import {Controller} from "@hotwired/stimulus";
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        bookingId: Number,
        paymentId: Number,
        litigantId: Number,
        litigantName: String,
    };

    meetingHappened() {
        const feedbackCashingModalController = this.application.getControllerForElementAndIdentifier(
            document.getElementById('payment-feedback-cashing-modal'),
            'payment--feedback-cashing-modal'
        );

        feedbackCashingModalController.bookingIdValue = this.bookingIdValue;
        feedbackCashingModalController.paymentIdValue = this.paymentIdValue;
        feedbackCashingModalController.hasMeetingHappenedValue = true;
        feedbackCashingModalController.open();
    }

    meetingDidNotHappen() {
        const feedbackCashingModalController = this.application.getControllerForElementAndIdentifier(
            document.getElementById('payment-feedback-cashing-modal'),
            'payment--feedback-cashing-modal'
        );

        if (this.litigantIdValue) {
            feedbackCashingModalController.litigantIdValue = this.litigantIdValue;
            feedbackCashingModalController.litigantNameValue = this.litigantNameValue;
        }

        feedbackCashingModalController.bookingIdValue = this.bookingIdValue;
        feedbackCashingModalController.paymentIdValue = this.paymentIdValue;
        feedbackCashingModalController.hasMeetingHappenedValue = false;
        feedbackCashingModalController.open();
    }
}
